import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'global-policy-distribution',
    standalone: false,
    template: `
        <div class="row">
            <mon-chart-bubble
                    class="col-48"
                    [height]="235"
                    [data]="data"
                    [series]="series"
                    [colors]="colors"
                    [options]="options"
                    [labels]="labels"></mon-chart-bubble>
        </div>
    `,
})
export class GlobalPolicyDistributionComponent implements OnInit {
    @Input() policies: any = [];

    data: any;
    series: any;
    colors: any;
    options: any;
    labels: any;

    constructor (private translateService: TranslateService) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        const priorities = {
            low: this.policies.filter((policy: any) => {
                return policy.priority === 'low';
            }),
            medium: this.policies.filter((policy: any) => {
                return policy.priority === 'medium';
            }),
            hard: this.policies.filter((policy: any) => {
                return policy.priority === 'high';
            }),
        };

        this.data = [
            this.filterDistribution(priorities, 1, 'violation'),
            this.filterDistribution(priorities, 2, 'required'),
            this.filterDistribution(priorities, 3, 'search'),
        ];
        this.series = [
            '',
            this.translateService.getString('High'),
            this.translateService.getString('Medium'),
            this.translateService.getString('Low'),
        ];
        this.labels = [
            '',
            this.translateService.getString('Unwanted'),
            this.translateService.getString('Required'),
            this.translateService.getString('Matches'),
        ];
        this.colors = ['#9EBFFA', '#ADD5FD', '#D5E4FE', '#D6E5FE'];
        this.options = {
            scales: {
                yAxes: [
                    {
                        gridLines: {
                            display: false,
                        },
                        ticks: {
                            max: this.series.length,
                            beginAtZero: true,
                            suggestedMax: this.series.length * 2,
                            maxTicksLimit: this.series.length * 2,
                            callback: (value: any, index: any) => {
                                return this.series[index];
                            },
                        },
                    },
                ],
                xAxes: [
                    {
                        gridLines: {
                            display: false,
                        },
                        ticks: {
                            max: this.labels.length,
                            beginAtZero: true,
                            suggestedMax: this.labels.length * 2,
                            maxTicksLimit: this.labels.length * 2,
                            callback: (value: any, index: any) => {
                                return this.labels[index];
                            },
                        },
                    },
                ],
            },
            tooltips: {
                mode: 'point',
                callbacks: {
                    label: (tooltipItem: any, data: any) => {
                        return (
                            data.labels[tooltipItem.xLabel] +
                            ': ' +
                            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].val
                        );
                    },
                },
            },
        };
    }

    private filterDistribution (priorities: any, x: any, mode: any): any {
        const result: any = [];
        let y = 1;

        // eslint-disable-next-line guard-for-in
        for (const i in priorities) {
            const val = priorities[i].filter((policy: any) => {
                return policy.mode === mode && policy.matches_count > 0;
            }).length;
            result.push({
                x: x,
                y: y,
                r: this.setRadius(val),
                val: val,
            });
            y += 1;
        }
        return result;
    }

    private setRadius (val: any): any {
        if (val > 0) {
            const maxRadiusOnChartElements = 25; // Pixel values
            const minRadiusOnChartElements = 5;
            if (val > maxRadiusOnChartElements - minRadiusOnChartElements) {
                return maxRadiusOnChartElements;
            }
            return val + minRadiusOnChartElements;
        }
        return 0.00001;
    }
}
